import { Component, Inject, OnInit, OnChanges, ViewChild } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

import {
  ControlContainer,
  UntypedFormBuilder,
  UntypedFormGroup,
  FormControl,
  FormGroupDirective,
  Validators,
} from "@angular/forms";
@Component({
    selector: "app-date-group-options",
    templateUrl: "./date-group-options.component.html",
    styleUrls: ["./date-group-options.component.scss"],
    standalone: false
})
export class DateGroupOptionsComponent implements OnInit, OnChanges {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<DateGroupOptionsComponent>,
    private fb: UntypedFormBuilder
  ) {
    if (data) {
      this.name = data.name;
      this.option = data.option;
    }
  }

  public canvasType!: any;
  public fromCreate = false;
  public editForm!: UntypedFormGroup;
  public name;
  public option: any = "M";

  onNoClick(): void {
    this.dialogRef.close();
  }
  apply(): void {
    this.dialogRef.close(this.editForm.get("range")!.value);
  }
  initForm() {
    this.editForm = this.fb.group({
      range: [this.option, Validators.required],
    });
  }

  ngOnChanges(): void {}

  ngOnInit(): void {
    this.initForm();
  }
}
